<template>
  <b-container>
    <b-row class="justify-content-md-center">
      <b-col v-for="sm in content" v-bind:key="sm._id">
        <b-link :href="sm.link" target="_blank">
          <b-img alt="sm.alt" class="social-icon" :src="getImagePath(sm.iconSrc)"></b-img>
        </b-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { getImageSrc } from '@/utils/assets';

export default {
  name: 'SocialMedia',
  props: {
    content: Array,
  },
  data() {
    return {};
  },
  methods: {
    getImagePath(imageName) {
      return getImageSrc(imageName);
    },
  },
};
</script>

<style scoped lang="scss">
.social-icon {
  height: 25px;
  width: 25px;
  &:hover {
    cursor: pointer;
    opacity: 85%;
  }
}
</style>
